import { useMutation, useQueryClient } from '@tanstack/react-query';
import { forceDeleteContact } from '../../api/apiContacts';
import toast from 'react-hot-toast';

export const useForceDeleteContact = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: forceDeleteContact,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['contacts'] });
            toast.success(data.message || 'Message permanently deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to permanently delete message';
            toast.error(errorMessage);
        },
    });
};